import Axios from 'axios';

import AppContext from 'app/AppContext';
import CoreApi from './Core';

export default class Vaffa {
    static async MyStores() {
        return await Axios.get(AppContext.s["api-url"] + "/mystores")
            .catch((error) => {
                console.log('error ' + error);
                CoreApi.errorLog(error);
            });
    }
}